import { offerExpired } from './offers.js';
// Tauler «Avui» de l'agent (§10.4): ajunta el que li toca fer, a partir de les consultes obertes.
// Única font de veritat per al que surt a la pantalla (§10.1).
export const EXPIRING_SOON_MS = 24 * 60 * 60 * 1000;
export function todayDigest(rows, uid, nowIso) {
    const now = Date.parse(nowIso);
    const soon = (iso) => iso != null && Date.parse(iso) > now && Date.parse(iso) - now <= EXPIRING_SOON_MS;
    const digest = { toAnswer: [], quotesWaiting: [], quotesToConfirm: [], expiringSoon: [] };
    for (const r of rows) {
        if ((r.unread?.[uid] ?? 0) > 0)
            digest.toAnswer.push(r);
        const o = r.offer;
        if (o?.status === 'sent' && !offerExpired(o, nowIso)) {
            digest.quotesWaiting.push(r);
            if (soon(o.validUntil))
                digest.expiringSoon.push({ row: r, kind: 'quote', at: o.validUntil });
        }
        if (o?.status === 'accepted')
            digest.quotesToConfirm.push(r);
        // La reserva provisional de 24 h de la consulta (si no l'ha substituïda un pressupost).
        if (r.hold.requested && !r.hold.released && !o && soon(r.hold.until))
            digest.expiringSoon.push({ row: r, kind: 'hold', at: r.hold.until });
    }
    digest.expiringSoon.sort((a, b) => a.at.localeCompare(b.at));
    return digest;
}
/** No hi ha res pendent. */
export const isAllClear = (d) => d.toAnswer.length + d.quotesWaiting.length + d.quotesToConfirm.length + d.expiringSoon.length === 0;
